import { Instagram } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

export default function Menciones({ datos, seccion }) {
  const menciones = datos.menciones || [];
  if (menciones.length === 0) return null;

  return (
    <section className="cv-seccion" aria-label={seccion.titulo}>
      <div className="cv-seccion-interior">
        <EncabezadoSeccion p="cv" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="cv-titulo-menciones" />
        <div className="cv-menciones">
          {menciones.map((m, i) => (
            <Reveal key={i} delay={i * 0.07}>
              <figure className="cv-mencion" data-testid={`cv-mencion-${i}`}>
                <img className="cv-mencion-foto" src={m.foto} alt={`Fotografía de ${m.nombre}`} loading="lazy" />
                <figcaption>
                  <p className="cv-mencion-nombre">{m.nombre}</p>
                  <p className="cv-mencion-rol">{m.rol}</p>
                  {m.instagramUrl && (
                    <a
                      className="cv-mencion-ig"
                      href={m.instagramUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`Instagram de ${m.nombre}`}
                      data-testid={`cv-enlace-instagram-${i}`}
                    >
                      <Instagram strokeWidth={1.5} />
                    </a>
                  )}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
